'use strict';

var selectors = {
  searchInput: '.js-search-input',
  searchBtn: '.js-search-btn',
  dlrsList: '.js-dlrs-list',
  dlrsListContainer: '.js-dlrs-list-container',
  dlrItem: '#jsDlrItem',
  dlrItemClass: '.js-dlr-item',
  dlrsContainer: '.js-dlrs-container',
  dlrName: '.js-dlr-name',
  listMsg: '.js-list-message',
  searchMsg: '.js-search-message'
};

var dealerLocator = function () {
  var map = void 0,
      geocoder = void 0,
      myJson = { instalaciones: [] },
      coords = [],
      ids = [],
      infos = [],
      bubbles = [],
      pts = [],
      markers = [],
      images = [],
      imagesOn = [],
      attempt = 0,
      staticServer = void 0,
      currentArea = void 0,
      dealersInvolved = void 0;

  var _setCurrentArea = function _setCurrentArea(value) {
    return currentArea = value;
  },
      _getCurrentArea = function _getCurrentArea() {
    return currentArea;
  };

  var _setDealersInvolved = function _setDealersInvolved(value) {
    return dealersInvolved = value;
  },
      _getDealersInvolved = function _getDealersInvolved() {
    return dealersInvolved;
  };

  var _createGMap = function _createGMap() {
    var mapOptions = {
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      mapTypeControl: false,
      panControl: false
    };

    staticServer = 'https://estatico.nissan.pt';

    var area = _getCurrentArea();

    switch (area) {
      case 'portugal':
        mapOptions.center = new google.maps.LatLng(39.5, -8);
        mapOptions.zoom = 6;
        break;
      case 'madeira':
        mapOptions.center = new google.maps.LatLng(32.76, -16.69);
        mapOptions.zoom = 9;
        break;
      case 'acores':
        mapOptions.center = new google.maps.LatLng(38.33, -28);
        mapOptions.zoom = 7;
        break;
      default:
        mapOptions.center = new google.maps.LatLng(39.5, -8);
        mapOptions.zoom = 6;
        break;
    }

    map = new google.maps.Map(document.getElementById('google-map'), mapOptions);
  };

  var _loadGMAPI = function _loadGMAPI() {
    $.ajax({
      // Loading API
      // url: `https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&libraries=places&language=pt-PT&key=AIzaSyBbjzipLV9aXsivID8Qro2HkYi7lI4u7Uc`,
      url: 'https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&libraries=places&language=pt_PT',
      dataType: 'script',
      complete: function complete() {
        geocoder = new google.maps.Geocoder();
        _createGMap(); // Initializing google map
      }
    });
  };

  var _searchDealerEvent = function _searchDealerEvent() {
    // Handling search dealer button event
    $(selectors.searchBtn).on('click', function (event) {
      event.preventDefault();
      var value = $(selectors.searchInput).val().trim();
      if (value !== '') {
        if (_validateCP(value)) {
          _searchPosition($(selectors.searchInput).val());
          attempt = 0;
        }
      }
    });

    $(selectors.searchInput).on('keyup', function (ev) {
      var value = $(selectors.searchInput).val().trim();
      if (ev.keyCode === 13 && value !== '') {
        if (_validateCP(value)) {
          _searchPosition($(this).val());
          $(this).trigger('blur');
        }
      }
    });
  };

  var _validateCP = function _validateCP(value) {
    var area = _getCurrentArea();

    var cpRules = {
      cpES_AD: function cpES_AD(value) {
        var re = new RegExp('^([0-4][0-9]{4}|(50|51|52)[0-9]{3}|AD[0-9]{3})$');
        return re.test(value);
      },

      baleares: function baleares(value) {
        var re = new RegExp(/^07/);
        return re.test(value);
      },

      canarias: function canarias(value) {
        var re = new RegExp(/^35|38/);
        return re.test(value);
      },

      onlyNumbers: function onlyNumbers(value) {
        if (value.trim() !== '') {
          var re = new RegExp(/^\d+$/g);
          return re.test(value);
        } else {
          return true;
        }
      }
    };

    function checkCP(value) {
      var re = new RegExp('^([0-9]{4}-[0-9]{3})$');
      return re.test(value);
    }

    if (!checkCP(value)) {
      _setSearchMsg('Código postal inválido');
      return false;
    } else {
      return true;
    }

    return true;
  };

  var _showErrorArea = function _showErrorArea() {
    var areaStr = utils.capitalize(_getCurrentArea());
    _setSearchMsg('Por favor, introduza um c\xF3digo postal v\xE1lido para ' + areaStr);
  };

  var _showErrorNoResults = function _showErrorNoResults() {
    _setSearchMsg('Não foi encontrado nenhum valor.');
  };
  var _getDealersJSON = function _getDealersJSON(value) {
    var errorTxt = 'Não foi encontrado nenhum valor.';

    $.ajax({
      dataType: 'script',
      url: 'https://serviciosweb.nissan.es/dloc/localizador?value=' + encodeURIComponent(value),
      success: function success() {
        if (json.status === 'OK') {
          _searchDealers(value, json.results[0].geometry.location.lat, json.results[0].geometry.location.lng);
        } else {
          // ZERO_RESULTS
          if (json.status === 'ZERO_RESULTS') {
            _clearDealersList();
            _setSearchMsg(errorTxt);
          }

          // OVER_QUERY_LIMIT ---> Common message
          if (json.status === 'OVER_QUERY_LIMIT') {
            if (attempt < 10) {
              _getDealersJSON(value);
              attempt++;
              console.log('Intento nº', attempt);
            } else {
              _clearDealersList();
              _setSearchMsg('Erro. Por favor, tente novamente mais tarde.');
              console.error('Se ha intentado ' + attempt + ' veces!!');
            }
          }
        }
      },
      error: function error() {
        _setSearchMsg('Erro. Por favor, tente novamente mais tarde.');
      }
    });
  };

  var _searchPosition = function _searchPosition(value) {
    _hideMarkers();
    _setSearchMsg('<p class="loader-img"><span class="loader"></span></p>');
    $(selectors.dlrsList).slideUp(); // Empty plants list
    _clearDealersList();
    _getDealersJSON(value);
  };

  var _searchDealers = function _searchDealers(value, lat, lng) {
    var url = 'https://serviciosweb.nissan.es/dloc/concesionario?pMode=busqueda&pvProvincia=' + encodeURIComponent(value) + '&vlatitud=' + lat + '&vlongitud=' + lng + '&pvPais=pt&pvTipoPeticion=stock';

    $.ajax({
      dataType: 'script',
      url: url,
      success: function success() {
        myJson = json_concesiones;
        var all = value.trim() === '' ? true : false;
        var dealersInArea = _filterDealersInCurrentArea(myJson.instalaciones);
        if (dealersInArea.length > 0) {
          var dealersResultInvolved = _filterDealersInvolved(dealersInArea);
          console.log('dealersInArea', dealersInArea);
          console.log('dealersResultInvolved', dealersResultInvolved);
          if (dealersResultInvolved.length > 0) {
            _loadDealers(dealersResultInvolved, all);
          } else {
            _showErrorNoResults();
          }

          //_loadDealers(dealersInArea, all)
        } else {
          _showErrorArea();
        }
      },
      error: function error() {
        _setSearchMsg('A busca não pôde ser levada a cabo.');
      }
    });
  };

  var _filterDealersInCurrentArea = function _filterDealersInCurrentArea(dealers) {
    var area = _getCurrentArea();

    var madeira = ['madeira'];
    var acores = ['açores'];

    var result = void 0;

    switch (area) {
      case 'portugal':
        result = dealers.filter(function (dealer) {
          console.log(dealer.provincia);
          if (madeira.indexOf(dealer.provincia.toLowerCase()) === -1 && acores.indexOf(dealer.provincia.toLowerCase()) === -1) {
            return dealer;
          } else {
            return;
          }
        });
        break;
      case 'madeira':
        result = dealers.filter(function (dealer) {
          console.log(dealer.provincia, madeira.indexOf(dealer.provincia.toLowerCase()));
          if (madeira.indexOf(dealer.provincia.toLowerCase()) > -1) {
            return dealer;
          } else {
            return;
          }
        });
        break;
      case 'acores':
        result = dealers.filter(function (dealer) {
          console.log(dealer.provincia, acores.indexOf(dealer.provincia.toLowerCase()));
          if (acores.indexOf(dealer.provincia.toLowerCase()) > -1) {
            return dealer;
          } else {
            return;
          }
        });
        break;
    }
    return result;
  };

  var _filterDealersInvolved = function _filterDealersInvolved(dealers) {
    var dealersInvolved = _getDealersInvolved();
    console.log(dealersInvolved);
    return dealers.filter(function (dealer) {
      for (var i = 0; i < dealersInvolved.length; i++) {
        if (dealer.idPrincipal === dealersInvolved[i].codhost) return dealer;
      }
    });
  };

  var _loadDealers = function _loadDealers(dealers, all) {
    // Reset map variables
    coords = [];
    ids = [];
    infos = [];
    bubbles = [];
    pts = [];
    markers = [];
    images = [];
    imagesOn = [];

    var infotxt = '',
        misitems = dealers;

    _clearSearchMsg();

    // tagging Analytics
    gtagApp.init({
      page: 'peticion',
      area: gtag.area,
      model: gtag.modelo,
      cp: true
    });

    // Iterates for each plant object received to generate the plants list again

    var _loop = function _loop(i) {
      var num = String(i + 1);
      num = num.length === 1 ? '0' + num : num;
      images[i] = 'marker-off-' + num + '.png';
      imagesOn[i] = 'marker-on-' + num + '.png';

      var itOrder = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'Y', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AY', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX', 'AY', 'AZ'];

      var curInstalacion = misitems[i];
      ids[i] = curInstalacion.id;
      coords[i] = [Number(curInstalacion.latitud), Number(curInstalacion.longitud), curInstalacion.id];
      infos[i] = '<div class="bubble">\n                  <h4>' + curInstalacion.nombre + '</h4>\n                  <p>' + curInstalacion.direccion + '</p>\n                  <p>' + curInstalacion.cp + ' ' + curInstalacion.poblacion + '</p>\n                </div>';
      var $it = $(selectors.dlrItem).clone().removeAttr('id').attr('id', 'li-' + curInstalacion.id);
      $it.find('.js-it-order').text(itOrder[i]).on('click', function () {
        return _showMarker('' + curInstalacion.id);
      });
      $it.find('.js-it-name').text(curInstalacion.nombre);
      $it.find('.js-it-address').text(curInstalacion.direccion);
      $it.find('.js-it-postalcode').text(curInstalacion.cp);
      $it.find('.js-it-locality').text(curInstalacion.poblacion);
      $it.find('.js-it-province').text(curInstalacion.provincia);
      $it.find('.js-it-phone').text(curInstalacion.telefono);
      $it.find('.js-select-btn').on('click', function () {
        _concesSelected(curInstalacion.idPrincipal, curInstalacion.nombre, curInstalacion.cp);
      })
      // .attr('data-tracking-label', curInstalacion.id)
      // .attr('data-gtagdealer', curInstalacion.nombre)
      // .attr('data-gtagdealerid', curInstalacion.vcode)
      // .attr('data-gtagmodel', JSON.stringify(gtag.modelo))
      .attr({
        'data-tracking-label': curInstalacion.id,
        'data-gtagdealer': curInstalacion.nombre,
        'data-gtagdealerid': curInstalacion.vcode,
        'data-gtagmodel': JSON.stringify(gtag.modelo)
      });
      $(selectors.dlrsList).append($it);
    };

    for (var i = 0; misitems[i]; i++) {
      _loop(i);
    }
    $(selectors.dlrsList).slideDown();
    _createPointMarkerInfo(all);
    _placeMarkers();
    _adjustZoom();

    gtagApp.init({ page: 'peticion', area: gtag.area });
  };

  var _hideMarkers = function _hideMarkers() {
    for (var i = 0; markers[i]; i++) {
      markers[i].setVisible(false);
      bubbles[i].close(map);
    }
  };

  var _clearDealersList = function _clearDealersList() {
    $(selectors.dlrsList).empty();
  };

  var _clearSearchMsg = function _clearSearchMsg() {
    $(selectors.listMsg).addClass('hidden');
    $(selectors.searchMsg).empty().addClass('hidden');
  };

  var _setSearchMsg = function _setSearchMsg(msg) {
    _clearSearchMsg();
    $(selectors.searchMsg).html(msg).removeClass('hidden');
  };

  // LatLng points, Markers & Bubbles

  var _createPointMarkerInfo = function _createPointMarkerInfo(all) {
    for (var i = 0; coords[i]; i++) {
      pts[i] = new google.maps.LatLng(coords[i][0], coords[i][1]);

      var markerimg = staticServer + '/commons/gmap-markers/' + images[i];
      var markerimgOn = staticServer + '/commons/gmap-markers/' + imagesOn[i];

      markers[i] = new google.maps.Marker({
        position: pts[i],
        icon: markerimg,
        iconOff: markerimg,
        iconOn: markerimgOn,
        code: coords[i][2]
      });

      bubbles[i] = new google.maps.InfoWindow({ maxHeight: 320 });
      bubbles[i].setContent(infos[i]);
      bubbles[i].setPosition(pts[i]);
      if (all) {
        geocoder.geocode({ address: 'Spain' }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            map.setCenter(results[0].geometry.location);
            map.fitBounds(results[0].geometry.viewport);
            map.setZoom(map.getZoom() + 1);
          }
        });
      }
    }
  };

  var _placeMarkers = function _placeMarkers() {
    for (var k = 0; markers[k]; k++) {
      markers[k].setMap(map);
      bubbles[k].close(map);
      google.maps.event.addListener(markers[k], 'click', function () {
        var n = $.inArray(this, markers);
        for (var i = 0; markers[i]; i++) {
          markers[i].setIcon(markers[i].iconOff);
          if (i != n) {
            bubbles[i].close(map);
          }
        }
        this.setIcon(this.iconOn);
        this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
        bubbles[n].open(map, this);
        $('.bubble').parent().css('overflow', ''); //Solution for scroll infowindow bug
        // Mark item in list
        var myid = ids[n];
        var todositems = $(selectors.dlrItemClass);
        var item = $('#li-' + myid);
        if (!item.hasClass('redselected')) {
          todositems.removeClass('redselected');
          item.addClass('redselected');
        }
        $(selectors.dlrsListContainer).scrollTo(item);
      });
    }
  };

  var _adjustZoom = function _adjustZoom() {
    if (map) {
      if (pts.length > 1) {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < pts.length; i++) {
          bounds.extend(pts[i]);
        }
        map.fitBounds(bounds);
      } else {
        map.setCenter(pts[0]);
        map.setZoom(13);
      }
    }
  };

  var _showMarker = function _showMarker(id) {
    var todositems = $(selectors.dlrItemClass);
    var item = $('#li-' + id);
    if (!item.hasClass('redselected')) {
      todositems.removeClass('redselected');
      item.addClass('redselected');
    }
    for (var i = 0; i < markers.length; i++) {
      var curMarker = markers[i];
      if (curMarker.code == id) {
        curMarker.setIcon(staticServer + '/commons/gmap-markers/' + imagesOn[i]);
        bubbles[i].open(map, curMarker);
        var myPoint = new google.maps.LatLng(curMarker.position.lat(), curMarker.position.lng());
        map.panTo(myPoint);
        map.setZoom(12);
      } else {
        bubbles[i].close(map);
        curMarker.setIcon(staticServer + '/commons/gmap-markers/' + images[i]);
        $('#check-' + curMarker.code).removeAttr('checked');
      }
    }
  };

  var _concesSelected = function _concesSelected(codhost, dealername, cp) {
    dealerFormsManager.setSelection(codhost, dealername, cp);
  };

  // const _abreConces = () => {
  //   $('#nombreConces').text($('#nombreConces').attr('data-defecto'))
  //   $(selectors.dlrsContainer).slideDown('slow')
  // }

  var _init = function _init(area) {
    $.ajax({
      url: 'https://estatico.nissan.pt/resources/stock/data/dealers_participantes_auto_pt.json',
      dataType: 'json',
      success: function success(response) {
        _setDealersInvolved(response);
      },
      error: function error(_error) {
        console.error('error cargando dealers participantes');
      }
    });

    _setCurrentArea(area);

    _loadGMAPI();
    _searchDealerEvent();
  };

  return {
    init: _init,
    showMarker: _showMarker,
    concesSelected: _concesSelected
  };
}();